import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import "./style.scss";
import ZeroScreen from "./zero-screen";
import { useDispatch } from "react-redux";
import { getInvoiceDetails } from "../../../redux/slices";
import InvoiceSummary from "../account-summary/invoice-summary";
import TypeSelectDropdown from "./type-select-dropdown";
import AuditLogs from "./audit-logs";
import { isMobileTabDevice } from "../../../helpers/device-info-helper";
import { SALES_AUDIT_OPTIONS_MAP } from "../../../data/constants";

interface Props {
  getPayload: any;
  searchData: any;
  handleonSelectedIdChange: any;
  setSelectedSubType: any;
  selectedId: string;
  selectedSubType: string;
  searchIcon: boolean;
  handleInvoiceSummary: any;
  invoiceSummary: boolean;
}

function AuditDetails(props: Props) {
  const {
    getPayload,
    searchData,
    handleonSelectedIdChange,
    setSelectedSubType,
    selectedId,
    selectedSubType,
    searchIcon,
    handleInvoiceSummary,
    invoiceSummary,
  } = props;
  const auditLogData = useSelector(
    (state: RootState) => state.accountingReducer?.auditDetails
  );
  const auditFilterDetails = useSelector(
    (state: RootState) => state.accountingReducer?.auditFilterDetails
  );
  const dispatch = useDispatch();

  function fetchInvoiceDetails(saleId: string) {
    dispatch(getInvoiceDetails({ saleId }));
  }

  function renderAuditsList(auditList: any): JSX.Element {
    return (
      <AuditLogs
        setInvoiceSummary={handleInvoiceSummary}
        fetchInvoiceDetails={fetchInvoiceDetails}
        getPayload={getPayload}
        searchData={searchData}
        selectedId={selectedId}
        selectedSubType={selectedSubType}
      ></AuditLogs>
    );
  }

  function renderAuditLog(): JSX.Element {
    return (
      <div className="flex smd:flex-col smd:overflow-y-auto render-audit-container">
        <div className="w-[40%] smd:w-[100%] border-r-[0.5px] ml-16 mt-12 smd:m-4  bg-white">
          {auditFilterDetails && (
            <>
              {searchData?.value?.length === 0 && !searchIcon && (
                <TypeSelectDropdown
                  getPayload={getPayload}
                  auditFilterDetails={auditFilterDetails}
                  onSelectedIdChange={handleonSelectedIdChange}
                  handleonSelectedItemChange={setSelectedSubType}
                  defaultSelectedId={selectedId}
                  defaultSelectedSubType={selectedSubType}
                />
              )}
              <div className="overflow-y-auto">
                {searchData?.value?.length === 0 && !searchIcon && (
                  <div className="flex bg-white border-opacity-25 p-16 border-b-[1px] sm:py-[20px] sm:px-[16px]">
                    <div className="bg-white px-8 border-r-[1px] items-center tb:px-[24px] sm:pr-[10px] basis-1/2 gap-[8px] tb:gap-0 flex-1">
                      <span className="text-[rgba(0,0,0,0.70)] text-[14px] smd:text-[13px]">
                        {selectedId
                          ? "Revenue From " +
                            SALES_AUDIT_OPTIONS_MAP[selectedId].type
                          : "Revenue From All Orders"}
                      </span>
                      <br />
                      <span className="text-black text-[16px] py-8 smd:py-0 font-semibold">
                        {" "}
                        <span className="ml-2">
                          ₹
                          {Number(
                            auditFilterDetails?.auditSummary?.amount || 0
                          ).toFixed(2)}
                        </span>
                      </span>
                      <br />
                      <div className="text-[#3A5E8B]  text-[13px] flex font-normal smd:mt-[8px] items-center smd:text-[12px] mt-[4px] ">
                        <span className="mr-2">{"Total Revenue:"}</span>
                        <span className="ml-2">
                          ₹
                          {Number(
                            auditFilterDetails?.salesSummary?.amount || 0
                          ).toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div className="bg-white px-[24px] flex-1 basis-1/2 sm:w-[148px]">
                      <span className="text-[rgba(0,0,0,0.70)] text-[14px] smd:text-[13px]">
                        {selectedId
                          ? SALES_AUDIT_OPTIONS_MAP[selectedId].type + " Count"
                          : "All Orders Count"}
                      </span>
                      <br />
                      <span className="ml-2 text-[16px] font-semibold py-8 smd:py-0">
                        {auditFilterDetails?.auditSummary?.count || 0}
                      </span>
                      <br />
                      <div className="text-[#3A5E8B] flex text-[13px] font-normal smd:mt-[8px] items-center smd:text-[12px] mt-[4px]">
                        <span className="mr-2">{"Total Orders:"}</span>
                        <span className="ml-2">
                          {auditFilterDetails?.salesSummary?.count || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                <>
                  {searchData?.value?.length > 0 && (
                    <div className="text-14 font-normal p-16 opacity-50 border-b-[1px] border-[#ECECEC]">
                      {searchData.results.length === 0
                        ? "No"
                        : searchData.results.length}{" "}
                      results found
                    </div>
                  )}
                  <div className="h-[calc(100vh-312px)]  pb-[8px] bg-white">
                    {renderAuditsList(searchData || {})}
                  </div>
                </>
              </div>
            </>
          )}
        </div>

        {invoiceSummary && (
          <div className="w-[59%] smd:w-[100%] mr-16 mt-12 bg-white">
            <InvoiceSummary
              closeInvoiceDetails={handleInvoiceSummary}
              hideBackButton={!isMobileTabDevice()}
            />
          </div>
        )}
      </div>
    );
  }
  return (
    <>
      {!(invoiceSummary && isMobileTabDevice()) || !isMobileTabDevice()
        ? renderAuditLog()
        : invoiceSummary && (
            <div className="w-[60%] smd:w-[100%]">
              <InvoiceSummary
                closeInvoiceDetails={handleInvoiceSummary}
                hideBackButton={!isMobileTabDevice()}
              />
            </div>
          )}
    </>
  );
}

export default AuditDetails;
